
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosindhurgtaxi() {



    const cardData =
    {
        keyword: 'Pune to Sindhudurg Taxi',
        heading: 'Platinum24 Cabs: Pune to Sindhudurg Taxi',
        headingDescription: ' Platinum24 Cabs provides dependable Pune to Sindhudurg Taxi services, ideal for family vacations, coastal tours, and historical explorations. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a safe and comfortable ride along the scenic Konkan coastline. With professional chauffeurs, punctual service, and transparent fares, we make your journey to Sindhudurg Fort, Tarkarli Beach, and other attractions hassle-free. Whether it’s a one-way drop, round-trip, or multi-day coastal holiday, Platinum24 Cabs guarantees affordable pricing, 24/7 availability, and a smooth travel experience from Pune to Sindhudurg.',

        top: 'Top Places to Visit in Sindhudurg with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Sindhudurg Fort",
    "description": "Sindhudurg Fort, built by Chhatrapati Shivaji Maharaj in 1664, is the pride of Konkan. Situated on an island in the Arabian Sea, it features massive stone walls, hidden passages, and temples inside. The fort houses Shivaji’s temple, the only one of its kind in India. Tourists reach it by boat and admire its strong maritime defenses. The fort narrates tales of Maratha naval power. Sindhudurg Fort is Maharashtra’s coastal heritage jewel."
  },
  {
    "title": "Tarkarli Beach",
    "description": "Tarkarli Beach is famous for its crystal-clear waters, white sands, and water sports. It is Maharashtra’s hotspot for scuba diving, snorkeling, and parasailing. The beach also offers dolphin-spotting boat rides. Couples and families love its peaceful sunsets. Nearby resorts serve authentic Malvani seafood. Tarkarli is Sindhudurg’s adventure and leisure paradise."
  },
  {
    "title": "Malvan",
    "description": "Malvan town is the cultural and culinary hub of Sindhudurg. Known for its spicy Malvani cuisine, it offers seafood delicacies like solkadhi, fish thali, and fried surmai. Malvan is also famous for Alphonso mangoes and cashew products. Visitors explore local markets for spices and handicrafts. The town is the gateway to Sindhudurg Fort and nearby beaches. Malvan is Sindhudurg’s lively blend of history and flavor."
  },
  {
    "title": "Rock Garden, Malvan",
    "description": "Rock Garden in Malvan is a beautiful landscaped spot overlooking the Arabian Sea. Waves crashing against rocky shores create mesmerizing views. Tourists enjoy evening walks, photography, and sunsets here. It is well-maintained with pathways, seating, and gardens. Families find it relaxing while couples enjoy the romantic atmosphere. Rock Garden is Sindhudurg’s scenic sunset point."
  },
  {
    "title": "Devbag Beach",
    "description": "Devbag Beach, located at the confluence of the Karli River and Arabian Sea, is a serene destination near Tarkarli. It offers backwater boat rides, birdwatching, and water sports. The Sangam Point, where the river meets the sea, is a stunning sight. Fishing boats line the shores, adding a rustic charm. It is quieter than Tarkarli, perfect for peace seekers. Devbag is Sindhudurg’s hidden coastal treasure."
  },
  {
    "title": "Napne Waterfall",
    "description": "Napne Waterfall is a seasonal monsoon attraction in Sindhudurg’s lush interiors. Surrounded by forests, it is perfect for trekking and nature photography. The sound of gushing waters and chirping birds creates a serene environment. Locals also consider the waterfall area sacred. Adventure enthusiasts camp nearby to enjoy its beauty. Napne is Sindhudurg’s refreshing natural escape."
  },
  {
    "title": "Vengurla Beach & Lighthouse",
    "description": "Vengurla Beach is a pristine stretch of sand dotted with cashew and coconut trees. The nearby Vengurla Lighthouse offers panoramic views of the Arabian Sea. The beach is ideal for swimming, sunbathing, and quiet getaways. Fishing villages around give insights into coastal life. Sunset views here are spectacular. Vengurla is Sindhudurg’s peaceful seaside retreat."
  },
  {
    "title": "Kunkeshwar Temple & Beach",
    "description": "Kunkeshwar Temple, dedicated to Lord Shiva, stands beautifully on a seaside cliff. Known as the ‘Kashi of South Konkan,’ it attracts thousands of pilgrims. The temple’s stunning backdrop of the Arabian Sea makes it unique. The adjacent beach is clean and ideal for relaxation. Festivals like Mahashivratri are celebrated with devotion here. Kunkeshwar is Sindhudurg’s sacred coastal shrine."
  },
  {
    "title": "Amboli Ghat",
    "description": "Amboli Ghat, located near Sindhudurg, is a hill station in the Western Ghats. Famous for its waterfalls, viewpoints, and biodiversity, it is called the ‘Queen of Konkan.’ Monsoon transforms Amboli into a misty wonderland. Trekkers and nature lovers enjoy exploring its forest trails. The Hiranyakeshi Temple and caves add spiritual charm. Amboli is Sindhudurg’s misty mountain getaway."
  },
  {
    "title": "Scuba Diving & Water Sports in Malvan",
    "description": "Malvan is Maharashtra’s prime destination for scuba diving and snorkeling. Clear waters around Sindhudurg Fort and Tarkarli make it perfect for underwater adventures. Divers witness colorful corals and marine life. Certified instructors guide beginners safely. Other activities like jet skiing, banana boat rides, and parasailing add fun. Scuba diving is Sindhudurg’s ultimate adventure experience."
  }
],


      "services": [
    {
      "name": "Pune to Sindhudurg Taxi Service",
      "description": "Enjoy a comfortable and scenic ride with our Pune to Sindhudurg Taxi Service. Whether you're heading for a weekend getaway or visiting family, our taxis offer a smooth journey with professional drivers and well-maintained vehicles. Choose from sedans, SUVs, or tempo travellers to match your travel group and budget. Our service is available 24x7, ensuring timely pickups and flexible scheduling for your convenience."
    },
    {
      "name": "Sindhudurg Cab from Pune",
      "description": "Book a Sindhudurg Cab from Pune for a relaxed and stress-free road trip. Our cabs are equipped with modern amenities, and our drivers are experienced in long-distance routes. Whether you're traveling solo, with family, or in a group, we offer multiple cab options to suit your preferences. Make your journey enjoyable with music, scenic stops, and custom itineraries."
    },
    {
      "name": "Pune Sindhudurg Taxi Booking",
      "description": "Use our fast and reliable Pune Sindhudurg Taxi Booking system to reserve your cab online or over the phone. With instant confirmation, transparent pricing, and no hidden charges, planning your trip to Sindhudurg has never been easier. Avail seasonal discounts and package deals for round trips or extended stays."
    },
    {
      "name": "Taxi Service Pune to Sindhudurg",
      "description": "Our Taxi Service from Pune to Sindhudurg offers flexible travel options for tourists, families, and corporate clients. Enjoy door-to-door pickup and drop, comfortable seating, and on-road assistance throughout your journey. Perfect for vacations or religious trips, our service guarantees a peaceful and punctual ride."
    },
    {
      "name": "Sindhudurg Cab Rental Pune",
      "description": "Rent a cab from Pune to Sindhudurg with our hassle-free Cab Rental service. Choose hourly, daily, or custom packages depending on your travel duration. Our rental service includes fuel, tolls, and driver charges in easy-to-understand fare structures. Experience the convenience of a private vehicle with no logistical worries."
    },
    {
      "name": "Pune to Sindhudurg Taxi Fare",
      "description": "Get affordable Pune to Sindhudurg Taxi Fare with our transparent and upfront pricing policy. No surprises—just clean fares based on vehicle type, trip type (one-way or round), and distance. Compare fares online and choose the option that best suits your travel budget and preferences."
    },
    {
      "name": "Sindhudurg Private Taxi Pune",
      "description": "Enjoy the comfort of a Sindhudurg Private Taxi from Pune, ideal for families, couples, and small groups looking for privacy and flexibility. Our private taxis come with professional chauffeurs, GPS tracking, and optional add-ons like baby seats and WiFi. Make your journey secure, personalized, and enjoyable."
    },
    {
      "name": "Sindhudurg Cab Packages Pune",
      "description": "Explore our exclusive Sindhudurg Cab Packages from Pune, tailored for weekend getaways, temple visits, and beach holidays. Packages include sightseeing options, multi-day rentals, and discounted round trips. Book in advance and enjoy special perks, including zero cancellation fees and complimentary water bottles."
    },
    {
      "name": "Pune to Sindhudurg One Way Cab",
      "description": "Book a one-way cab from Pune to Sindhudurg for a budget-friendly and flexible travel solution. Ideal for guests not returning the same day, our one-way taxi service ensures you only pay for the journey you need. Enjoy all the benefits of a private taxi at reduced rates."
    },
    {
      "name": "Taxi Charges Pune to Sindhudurg",
      "description": "Review detailed Taxi Charges from Pune to Sindhudurg on our fare page or during booking. Pricing varies based on car type (hatchback, sedan, SUV), trip duration, and add-ons. We believe in complete transparency and provide all-inclusive quotes—no last-minute surprises."
    },
    {
      "name": "Pune to Sindhudurg Taxi Hire",
      "description": "Hire a taxi from Pune to Sindhudurg with us for a dependable and efficient ride. Ideal for long journeys, our taxi hire service includes air-conditioned vehicles, verified drivers, and route customization. Choose hourly or per-kilometer pricing depending on your travel style."
    },
    {
      "name": "Sindhudurg Weekend Trip Cab Pune",
      "description": "Plan your weekend trip to the coastal beauty of Sindhudurg with our specialized Weekend Trip Cab from Pune. Whether you’re planning a beach vacation, historic fort visit, or coastal trek, our service ensures safe, relaxed, and timely transportation for solo travelers and groups."
    },
    {
      "name": "Pune Sindhudurg Outstation Taxi",
      "description": "Our Pune Sindhudurg Outstation Taxi service is perfect for multi-day or one-day outstation travel. Vehicles are equipped for long journeys with luggage space, comfortable interiors, and experienced drivers who know the best rest stops and scenic spots on the way."
    },
    {
      "name": "Sindhudurg Taxi with Driver Pune",
      "description": "Travel in comfort and confidence with our Sindhudurg Taxi with Driver from Pune. All drivers are licensed, background-verified, and trained for long trips. Enjoy a chauffeured experience that includes navigation, trip assistance, and professional service throughout your journey."
    },
    {
      "name": "Taxi Service Pune to Sindhudurg",
      "description": "Our full-service taxi from Pune to Sindhudurg offers convenience, safety, and custom travel options. Whether it’s a pilgrimage, a family vacation, or a solo road trip, we provide clean vehicles, reliable drivers, and real-time support to make your travel experience memorable."
    }
  ],
  "tableData": [
    ["Pune to Sindhudurg Taxi Service", "Sindhudurg Cab from Pune"],
    ["Pune Sindhudurg Taxi Booking", "Taxi Service Pune to Sindhudurg"],
    ["Sindhudurg Cab Rental Pune", "Pune to Sindhudurg Taxi Fare"],
    ["Sindhudurg Private Taxi Pune", "Sindhudurg Cab Packages Pune"],
    ["Pune to Sindhudurg One Way Cab", "Taxi Charges Pune to Sindhudurg"],
    ["Pune to Sindhudurg Taxi Hire", "Sindhudurg Weekend Trip Cab Pune"],
    ["Pune Sindhudurg Outstation Taxi", "Sindhudurg Taxi with Driver Pune"],
    ["Taxi Service Pune to Sindhudurg", "—"]
  ],


         "whychoose": [
    {
      "WhyChooseheading": "Comfortable Pune to Sindhudurg Taxi Service",
      "WhyChoosedescription": "Platinum24 Cabs provides reliable and convenient taxi services from Pune to the coastal district of Sindhudurg."
    },
    {
      "WhyChooseheading": "Experienced Drivers with Route Expertise",
      "WhyChoosedescription": "Our professional drivers are well-acquainted with the Pune to Sindhudurg route, ensuring a smooth and safe journey."
    },
    {
      "WhyChooseheading": "Clean and Air-Conditioned Cabs for Long Travel",
      "WhyChoosedescription": "Travel comfortably in well-maintained, sanitized vehicles ideal for long-distance coastal trips."
    },
    {
      "WhyChooseheading": "Flexible Booking Options – One-Way or Round Trip",
      "WhyChoosedescription": "Choose travel plans that suit your itinerary with both one-way and round trip taxi options available."
    },
    {
      "WhyChooseheading": "Transparent and Competitive Pricing",
      "WhyChoosedescription": "No hidden charges—enjoy fair pricing inclusive of fuel, tolls, and driver allowances."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Seamless Booking",
      "WhyChoosedescription": "Our team is always available to help with bookings, modifications, or special travel needs."
    },
    {
      "WhyChooseheading": "Ideal for Family Trips, Vacations, and Coastal Tours",
      "WhyChoosedescription": "Perfect choice for those planning a relaxing getaway or visiting heritage sites in Sindhudurg."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Choices for Every Travel Need",
      "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or tempo travellers based on group size and comfort."
    }
  ]





























    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs provide taxi services from Pune to Sindhudurg?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable taxi services from Pune to Sindhudurg for one-way and round trips.',
    },
    {
        question: 'How can I book a Pune to Sindhudurg taxi with Platinum24 Cabs?',
        answer: 'You can easily book your Pune to Sindhudurg taxi through our website, mobile app, or by contacting our 24x7 customer support.',
    },
    {
        question: 'What types of vehicles are available for Pune to Sindhudurg trips?',
        answer: 'We offer a wide range of vehicles including sedans, SUVs, tempo travellers, and luxury cars to match your travel needs and group size.',
    },
    {
        question: 'Are the drivers experienced for the Pune to Sindhudurg route?',
        answer: 'Yes, our drivers are professional and experienced with long-distance travel, including the Pune to Sindhudurg route.',
    },
    {
        question: 'Can I book a round trip taxi from Pune to Sindhudurg?',
        answer: 'Absolutely! We offer flexible round-trip taxi packages for Pune to Sindhudurg with customized itineraries and return scheduling.',
    },
    {
        question: 'What is included in the Pune to Sindhudurg taxi fare?',
        answer: 'The fare includes driver charges, fuel, tolls, and taxes. Additional charges may apply for extra stops, waiting time, or night travel.',
    },
    {
        question: 'Can I choose my pickup and drop-off locations for the trip?',
        answer: 'Yes, you can specify any pickup and drop-off points in Pune and Sindhudurg as per your convenience.',
    },
    {
        question: 'Are the vehicles sanitized and safe for travel?',
        answer: 'Yes, all our vehicles are regularly sanitized and well-maintained, and our drivers follow strict safety and hygiene guidelines.',
    },
    {
        question: 'Do you offer multi-day taxi packages for Pune to Sindhudurg?',
        answer: 'Yes, we offer multi-day taxi rental options for extended stays in Sindhudurg or for sightseeing along the way.',
    },
    {
        question: 'Do you provide corporate bookings for Pune to Sindhudurg taxis?',
        answer: 'Yes, we offer corporate travel solutions including invoice support, flexible payment options, and priority service.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Nilesh Sawant',
        feedback: 'Booked a cab from Pune to Sindhudurg with Platinum24 Cabs — very professional driver and smooth journey!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Varsha Naik',
        feedback: 'Comfortable and on-time service for our family trip to Sindhudurg. Highly recommend Platinum24 Cabs!',
        rating: 5,
    },
];





























































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];






const sindhudurgTaxiSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable Pune to Sindhudurg Taxi Service offering cab rental, private taxis, and affordable packages for Sindhudurg trips with experienced drivers.",
  "areaServed": {
    "@type": "Place",
    "name": "Pune"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Pune to Sindhudurg Taxi Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "One Way Cab Pune to Sindhudurg"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Round Trip Taxi Service Pune to Sindhudurg"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Weekend Trip Cab Pune to Sindhudurg"
        }
      }
    ]
  },
  "serviceType": [
    "Pune to Sindhudurg Taxi Service",
    "Sindhudurg Cab from Pune",
    "Pune Sindhudurg Taxi Booking",
    "Taxi Service Pune to Sindhudurg",
    "Sindhudurg Cab Rental Pune",
    "Pune to Sindhudurg Taxi Fare",
    "Sindhudurg Private Taxi Pune",
    "Sindhudurg Cab Packages Pune",
    "Pune to Sindhudurg One Way Cab",
    "Taxi Charges Pune to Sindhudurg",
    "Pune to Sindhudurg Taxi Hire",
    "Sindhudurg Weekend Trip Cab Pune",
    "Pune Sindhudurg Outstation Taxi",
    "Sindhudurg Taxi with Driver Pune",
    "Taxi Service Pune to Sindhudurg"
  ],
  "telephone": "+91-XXXXXXXXXX"
};








    return (
        <div>

<Helmet>
  <title>Pune to Sindhudurg Taxi Service | Sindhudurg Cab Booking Pune</title>
  <meta
    name="description"
    content="Reliable Pune to Sindhudurg Taxi Service offering cab rental, private taxis, and affordable packages for Sindhudurg trips with experienced drivers."
  />
  <meta
    name="keywords"
    content="Pune to Sindhudurg Taxi Service, Sindhudurg Cab from Pune, Pune Sindhudurg Taxi Booking, Taxi Service Pune to Sindhudurg, Sindhudurg Cab Rental Pune, Pune to Sindhudurg Taxi Fare, Sindhudurg Private Taxi Pune, Sindhudurg Cab Packages Pune, Pune to Sindhudurg One Way Cab, Taxi Charges Pune to Sindhudurg, Pune to Sindhudurg Taxi Hire, Sindhudurg Weekend Trip Cab Pune, Pune Sindhudurg Outstation Taxi, Sindhudurg Taxi with Driver Pune, Taxi Service Pune to Sindhudurg"
  />
  <script type="application/ld+json">
    {JSON.stringify(sindhudurgTaxiSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/69.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetosindhurgtaxi;